<template>
  <div class="page fs16">
    <!-- banner -->
    <el-carousel :interval="5000" height="500px" arrow="always">
      <el-carousel-item
        class="bg-cover csp"
        style="background-image: url(https://static.wkanx.com/w002/M00/05/D1/CgIXgV6O5_SAG7__AAITrgieaMA381.jpg)"
        @click.native="showContactForm = true"
      >
        <img
          src="https://static.wkanx.com/w002/M00/07/DE/CgIXGF9YRYmAHxR6AABjaXwzQnA387.png"
          width="433"
          class="abs-center-hv"
        />
      </el-carousel-item>
      <el-carousel-item
        class="bg-cover tc color-white bg-bottom"
        style="background-image: url(https://static.wkanx.com/w002/M00/05/C9/CgIXgV6Nn82AKavPAAUi1-0ekpk821.jpg)"
      >
        <div class="abs-center-hv">
          <div style="transform: translate(0, -60px)">
            <div class="fs28 fwb m-b-5" style="letter-spacing: 6px">连接创造美好</div>
            <div class="fs16">尚网网络广告平台助力您实现商业目标</div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="rel tc bg-gray oh p-t-6">
      <div class="fs18 fwb m-t-6">选择尚网营销的理由</div>
      <div class="container bc m-t-4 m-b-8 tl">
        尚网营销凭借强大产品用户数优势，卡位碎片化上网的第一步，为客户提供全系列产品的广告资源覆盖用户移动上网场景。
      </div>
      <img src="https://static.wkanx.com/w002/M00/05/AF/CgIXlV6C6rGABr9yAAI6EP7zw2Q801.png" width="500" />
    </div>
    <div class="p-t-5 tc p-b-8">
      <div class="fs18 fwb m-t-5 m-b-7">新潜力族群“小镇青年”聚合平台，享受下沉流量红利</div>
      <div flex="main:center" class="sm-container m-t-4 m-b-6">
        <div flex-box="0" style="width: 33.33%">
          <img src="https://static.wkanx.com/w002/M00/05/AF/CgIXgV6C7baAaMGGAAAJcawzdPc763.png" width="82" alt />
          <div class="m-t-3 m-b-1">地域分布</div>
          <div>62%在三线及以下城市</div>
        </div>
        <div flex-box="0" style="width: 33.33%">
          <img src="https://static.wkanx.com/w002/M00/05/AF/CgIXlV6C7fGAbycKAAAYavN545w048.png" width="82" alt />
          <div class="m-t-3 m-b-1">男女画像比例</div>
          <div>6 : 4</div>
        </div>
        <div flex-box="0" style="width: 33.33%">
          <img src="https://static.wkanx.com/w002/M00/05/AF/CgIXGF6C7fqAcJZ3AAAcq_iHkLw320.png" width="82" alt />
          <div class="m-t-3 m-b-1">18-40岁占比</div>
          <div>60%以上</div>
        </div>
      </div>
    </div>
    <div class="bg-gray p-v-8">
      <div class="m-t-8 m-b-6 tc fs18 fwb">将客户的广告展现给精准用户</div>
      <div class="container m-b-8 bc m-t-2 tc">
        <div class="m-b-8">
          借助行业领先的数据精算和资讯流推荐，根据用户行为标签与特征，得到更精准的用户画像，识别每一位用户真实需求及兴趣爱好。
        </div>
        <img width="200" src="https://static.wkanx.com/w002/M00/05/B0/CgIXGF6DAKOAIgxnAADuktcPU5U167.png" alt />
      </div>
    </div>
    <div class="p-v-8">
      <div class="m-t-8 m-b-4 tc fs18 fwb">更精准的场景化广告投放</div>
      <div class="container tc">
        <div class="m-b-8">
          通过WiFi入口，形成原生天然的LBS，更精准的识别用户所处 场景，为客户提供更加便捷高效的场景化投放方式
        </div>
        <img src="https://static.wkanx.com/w002/M00/05/B0/CgIXgV6DAvqALp2KAADOWUvpTO0166.png" width="200" alt />
      </div>
    </div>
    <div class="bg-gray p-v-8">
      <div class="m-t-8 tc fwb">程序化创意投放方式让投放更加高效</div>
      <div class="container m-t-4">
        通过人工智能的计算方式，解决不同测试创意组合效率低下，素材效果测试预算不能自由掌控的问题，将预算倾斜给投放效果好的推广活动，灵活分配用推广预算，并减少推广预算的浪费
      </div>
      <div class="m-b-8 m-t-8 tc">
        <img width="380" src="https://static.wkanx.com/w002/M00/05/B0/CgIXlV6DBJeAL9YcAABScyN4Ppk358.png" alt />
      </div>
    </div>
    <div class="tc p-v-8">
      <div class="m-t-8 fs18 fwb">帮助客户实现商业目标</div>
      <div class="container m-t-4">
        通过不同的广告方式，助力客户实现从获客到品牌曝光的目的，更好更快速的实现商业目标
      </div>
      <div class="m-b-8 m-t-8 tc">
        <img width="600" src="https://static.wkanx.com/w002/M00/05/B0/CgIXGF6DBf-AVvg9AAW0iCsLCu8973.png" alt />
      </div>
    </div>
    <div class="p-v-8">
      <div class="fs18 tc m-b-2 fwb">通过尚网营销平台获取更多客户</div>
    </div>
    <ContactForm :show="showContactForm" @hide="showContactForm = false" />
  </div>
</template>

<script>
import ContactForm from '@/components/ContactFormDialog';
export default {
  components: { ContactForm },
  data() {
    return {
      showContactForm: false,
    };
  },
};
</script>
